module.exports = __webpack_public_path__ + "static/media/needs-1-outline.1df8f693.png";